import translateService from '../translate/translate.service';
import checkoutSummaryHtml from './checkoutsummary.component.html';
import './checkoutsummary.component.scss';

class CheckoutSummaryController {
    constructor($scope, CheckoutService, SnackbarService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.service = CheckoutService;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;
        this.showDiscount = false;
        this.showPiggyBank = false;
        this.discountCode = '';
        this.discountLoading = false;
        this.discountCodeHasError = false;
        this.piggyBankLoading = false;
        this.piggyBankValue = null;
        this.piggyBankValueHasError = false;
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            switch(this.step) {
                case 1:
                case 3:
                    this.service.load();
                    break;
            }
        }

        this.$scope.$watch(
            () => this.discountCode,
            () => {
                this.discountCodeHasError = false;
            }
        );
    }

    addDiscountCode() {
        if (this.discountCode.length < 1) {
            this.SnackbarService.add(this.translate.t('checkout.discount.mustNotBeEmpty'), 'error', true, 2000);
            return;
        }

        this.service.addDiscountCode(this.discountCode).then(
            () => {
                this.showDiscount = false;
                this.discountCode = '';
                this.discountLoading = false;

                this.SnackbarService.add(this.translate.t('checkout.discount.codeAdded'), 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
                this.discountCodeHasError = true;
            }
        );

        this.discountLoading = true;
    }

    removeDiscountCode() {
        this.discountLoading = true;

        this.service.removeDiscountCode().then(
            () => {
                this.discountLoading = false;

                this.SnackbarService.add(this.translate.t('checkout.discount.codeRemoved'), 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
            }
        );
    }

    setPiggyBankValue() {
        if (this.piggyBankValue <= 0) {
            this.SnackbarService.add(this.translate.t('checkout.piggyBank.amountTooLow'), 'error', true, 3000);
            return;
        }

        if (this.piggyBankValue > this.service.summary.gros_amount_to_pay) {
            this.piggyBankValue = this.service.summary.gros_amount_to_pay;
            this.SnackbarService.add(this.translate.t('checkout.piggyBank.cartAmountReduced'), 'error', true, 3000);
        }

        if (this.piggyBankValue > this.service.piggyBank.value) {
            this.piggyBankValue = this.service.piggyBank.value;
        }

        this.service.setPiggyBankValue(this.piggyBankValue).then(
            () => {
                this.showPiggyBank = false;
                this.piggyBankValue = null;
                this.piggyBankLoading = false;
            },
            () => {
                this.piggyBankLoading = false;
                this.piggyBankValueHasError = true;
            }
        );

        this.piggyBankLoading = true;
    }

    removePiggyBankValue() {
        this.service.setPiggyBankValue(0).then(
            () => {
                this.piggyBankValue = null;
                this.piggyBankLoading = false;

                this.SnackbarService.add(this.translate.t('checkout.piggyBank.removed'), 'success', true, 3000);
            },
            () => {
                this.piggyBankLoading = false;
                this.piggyBankValueHasError = true;
            }
        );

        this.piggyBankLoading = true;
    }
}

let checkoutSummaryComponent = {
    bindings: {
        step: '<'
    },
    template: checkoutSummaryHtml,
    controller: CheckoutSummaryController
}

export default checkoutSummaryComponent;
